import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../pnp-approval-workflow.constants';
import { getSettingsApprovalWorkflow } from '../pnp-approval-workflow.actions';

class pnpSettingsApprovalWorkflowGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpSettingsApprovalWorkflowGrid;
        this.filterTemplate = './pnp-approval-workflow-grid-filter.html';

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Document Category', mapper: 'documentCategory' },
            { title: 'Risk Levels', mapper: 'documentRiskLevels' },
            { title: 'Reviewers', mapper: 'reviewers' },
            { title: 'Approvers', mapper: 'approvers' },
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getSettingsApprovalWorkflow }
        )(this);
        this.filter.identifier = this.identifier;
        this.dataAction = this.getSettingsApprovalWorkflow;

        this.exportService = this.getSettingsApprovalWorkflow;

        this.init();
        this.buttonsDefault = this.buttons.concat();
    }


    $onDestroy() {
        this.destroy();
    }
}


pnpSettingsApprovalWorkflowGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpSettingsApprovalWorkflowGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: pnpSettingsApprovalWorkflowGridController,
    ...gridTpl
}
